import React from 'react';
import CitizenPortrait from './CitizenPortrait';
import HatIcon from './HatIcon';

/*
 * One culture, at full size.
 *
 * The header is the only place in the system where the culture name leads. Even
 * here the role sits directly under it, because the culture name is secondary
 * data: someone scanning this for what was actually worked on must not have to
 * learn a fiction first.
 *
 * Responsibilities are the world's moons. They are the same list in both
 * places, so the card and the sky cannot disagree about what a culture does.
 */
const CultureCard = ({ hat, compact = false, wide = false }) => {
  const night = hat.diurnal < 0.5;
  const body = hat.body ?? { moons: [], rings: 0, glow: 0 };

  return (
    <article
      className={`culture${compact ? ' is-compact' : ''}${wide ? ' is-wide' : ''}`}
      style={{ '--accent': `var(--tmc-hat-${hat.id})` }}
    >
      <CitizenPortrait hat={hat} wide={wide} />

      <div className="culture-body">
        <header className="culture-head">
          <h3>{hat.culture}</h3>
          <p className="culture-role">
            <HatIcon hatId={hat.id} size={15} />
            <strong>{hat.name}</strong>
            <span aria-hidden="true">·</span>
            {hat.count} pieces of work
          </p>
        </header>

        {wide && (
          <div className="culture-orbit-relation" aria-label="AI connects the inner and outer orbits">
            <span>Inner orbit</span>
            <strong>AI / boundary</strong>
            <span>Outer orbit</span>
          </div>
        )}

        <blockquote className="culture-creed">{hat.creed}</blockquote>

        {!compact && <p className="culture-citizens">{hat.citizens}</p>}

        <dl className="culture-world">
          <div>
            <dt>Sky</dt>
            <dd>{hat.diurnal === 0.5 ? 'Boundary' : night ? 'Night' : 'Day'}</dd>
          </div>
          <div>
            <dt>Settlement</dt>
            <dd>{hat.settlement}</dd>
          </div>
          <div>
            <dt>Moons</dt>
            <dd>{body.moons.length}</dd>
          </div>
          {body.rings > 0 && (
            <div>
              <dt>Rings</dt>
              <dd>{body.rings}</dd>
            </div>
          )}
        </dl>

        {!compact && (
          <>
            <p className="culture-label">Holds</p>
            <ul className="culture-moons">
              {body.moons.map((moon) => (
                <li key={moon}>{moon}</li>
              ))}
            </ul>
          </>
        )}

        {/* The definition is the substance, so it survives the compact cut. */}
        <p className="culture-definition">{hat.definition}</p>
      </div>
    </article>
  );
};

export default CultureCard;
